/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { LexplusFunktionDetailDto } from '../../models/lexplus-funktion-detail-dto';

export interface FunktionenControllerFindOneDetailsByIdV1$Params {
  id: number;
}

export function funktionenControllerFindOneDetailsByIdV1(http: HttpClient, rootUrl: string, params: FunktionenControllerFindOneDetailsByIdV1$Params, context?: HttpContext): Observable<StrictHttpResponse<LexplusFunktionDetailDto>> {
  const rb = new RequestBuilder(rootUrl, funktionenControllerFindOneDetailsByIdV1.PATH, 'get');
  if (params) {
    rb.path('id', params.id, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<LexplusFunktionDetailDto>;
    })
  );
}

funktionenControllerFindOneDetailsByIdV1.PATH = '/v1/funktionen/details/{id}';
